<template>
    <div id="app">
        <router-view/>
    </div>
</template>

<script>
export default {
    name: "app",
	globalData: {
		// env: 'dev' , // 开发环境--'dev'; 生产环境--'prod'; 测试环境--'uat'
	},
};
</script>

<style rel="stylesheet/scss" lang="scss">
@import "./styles/base";
@import "app.scss";
html {
    height: 100%;
}
body {
    height: 100%;
    overflow: hidden;
}
#app {
    height: 100%;
}

.menu .svg-icon {
    font-size: 20px;
    margin-right: 5px;
}

.YYY .el-upload-list--picture-card .el-upload-list__item {
    overflow: visible;
}
</style>
